import { render, staticRenderFns } from "./AddSystemArticle.vue?vue&type=template&id=1d988192&scoped=true&"
import script from "./AddSystemArticle.vue?vue&type=script&lang=js&"
export * from "./AddSystemArticle.vue?vue&type=script&lang=js&"
import style0 from "./AddSystemArticle.vue?vue&type=style&index=0&id=1d988192&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d988192",
  null
  
)

export default component.exports